import { render } from "./AppMain.vue?vue&type=template&id=72741d82&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=72741d82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72741d82"

export default script